import { MenuItemProcessingRule } from '../interfaces';

export const menuItemExistsRule: MenuItemProcessingRule = context => {
	if (context.existingItems === undefined) return context;

	const existingIds = new Set(context.existingItems.map(item => item.idArticulo));
	return {
		...context,
		items: context.items.filter(item => existingIds.has(item.idArticulo)),
	};
};
